<template>
  <div class="page-airdrop">
    
    <div class="container pt-5 pb-2">

      <div>
        <router-link 
          class="btn btn-outline-primary px-4"
          :to="{name: 'home'}"
          >
          Back
        </router-link>
      </div>
      <h2 class="tac c">
        {{lg('',{
          en: 'Airdrop Claim Center',
          zh: '',
        })}}
      </h2>
    </div>

    <div class="mb-4 text-center">
      {{lg('',{
        en: 'Coming Soon',
        zh: '即将开放 敬请期待',
      })}}
    </div>

    <div class="mb-5 mx-auto d-flex" style="max-width: 300px;">

      <span 
        class="btn d-inline-block mx-2 btn-primary rounded w-100"
        @click="actionSyncAll()"
        >
        {{lg('',{
          en: 'Sync dJGN',
          zh: '',
        })}}
      </span>

      <span 
        class="btn d-inline-block mx-2 btn-primary rounded w-100"
        @click="actionClaimAll()"
        >
        {{lg('',{
          en: 'Claim All',
          zh: '全部领取',
        })}}
      </span>

    </div>


    <div class="list-airdrop-cards px-2 mx-auto" style="max-width: 520px;">

      <!-- card 1 -->
      <div 
        v-for="item of list_main_airdrop"
        :key="item.id"
        class="item mb-4"
        >
        <airdropCard :item="item"/>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'

import list_main_airdrop from '@/data/main_list_airdrop.js'
import airdropCard from './airdrop_card.vue'

export default {
  name: 'airdrap',
  components: {
    airdropCard,
  },
  props: [],
  data() {
    return {
      list_main_airdrop: list_main_airdrop,
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions([
      'SyncAirdropAll',
      'claimAirdropAll',
    ]),
    actionSyncAll(){
      let v = this
      v.SyncAirdropAll()
    },
    actionClaimAll(){
      let v = this
      v.claimAirdropAll()
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .list-airdrop-cards{
    display: flex;
    flex-wrap: wrap;

    .item{
      &:empty{
        display: none;
      }
    }

    // mobile
    @media(max-width: 788px){
      margin: 0 10px;
      .item{
        // width: 100%;
        width: 45%;
        margin: 2.5%;
      }
    }

    // pc
    @media(min-width: 788px){
      margin: 0 50px;
      .item{
        width: 45%;
        margin: 2.5%;
      }
    }
  }
</style>